import * as Hls from "hls.js/dist/hls.light.js";

const attachVideo = (video: HTMLVideoElement) => {
  const videoSrc = video.getAttribute("data-src");
  if (!videoSrc) {
    return;
  }

  // First check for native browser HLS support
  if (video.canPlayType("application/vnd.apple.mpegurl")) {
    video.src = videoSrc;
  }
  // If no native HLS support, check if HLS.js is supported
  else if (Hls.isSupported()) {
    const hls = new Hls();
    hls.loadSource(videoSrc);
    hls.attachMedia(video);
  }
};

const init = () => {
  const videos = document.getElementsByClassName("js-hls-video");
  const lazyVideos: HTMLVideoElement[] = [];
  for (const video of videos) {
    if (!(video instanceof HTMLVideoElement)) {
      continue;
    }

    if (video.preload === "none") {
      lazyVideos.push(video);
    } else {
      attachVideo(video);
    }
  }

  const lazyVideoObserver = new IntersectionObserver(function(
    entries
  ) {
    entries.forEach(function(video) {
      if (video.isIntersecting && video.target instanceof HTMLVideoElement) {
        attachVideo(video.target);
        lazyVideoObserver.unobserve(video.target);
      }
    });
  });

  lazyVideos.forEach(function(lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
};

export default {
  init
};
